import styled from "styled-components";

import { T_TITLE_4_NORMAL } from "../../../global.style";

export const StyledNumericWriteLine = styled.div`
    display: flex;
    ${T_TITLE_4_NORMAL};
`;